import React from "react";
import Seo from "../seo/seo";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="container mx-auto p-4">
      <Seo
        title="Privacy Policy | Merge Images Stackasian"
        description="Read the privacy policy for Merge Images Stackasian, including how we collect, use, and protect your data."
      />
      <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold">Introduction</h2>
          <p>
            At Merge Images Stackasian, your privacy is of paramount importance to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and services.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Information We Collect</h2>
          <p>
            We may collect the following types of information when you visit our website or use our services:
          </p>
          <ul className="list-disc pl-6">
            <li>Personal identification information (Name, Email, etc.)</li>
            <li>Usage data (pages visited, time spent on the website, etc.)</li>
            <li>Cookies and tracking information for website analytics</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">How We Use Your Information</h2>
          <p>
            The information we collect may be used in the following ways:
          </p>
          <ul className="list-disc pl-6">
            <li>To improve our website and services</li>
            <li>To personalize user experience</li>
            <li>To send periodic emails with updates, newsletters, or offers</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Data Protection</h2>
          <p>
            We implement a variety of security measures to maintain the safety of your personal information.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Third-Party Services</h2>
          <p>
            We do not sell or rent your personal information to third parties. However, we may share your information with third-party vendors who provide services such as website hosting, email delivery, and analytics.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Your Rights</h2>
          <p>
            You have the right to access, update, or delete your personal information. If you would like to exercise any of these rights, please contact us.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will post the updated policy on this page and indicate the date it was last updated.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Contact Information</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at Resize Images Stackasian.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;